import {BaseModel} from "../base.model";

export interface Point extends BaseModel {
  
}

export const defaultPoint: Readonly<Point> = {};